import { VOILUTFunctionType } from '../enums';
import { toLowHighRange } from './windowLevel';
export default function getVOIRangeFromWindowLevel(windowWidth, windowCenter, voiLUTFunction = VOILUTFunctionType.LINEAR) {
    let center;
    let width;
    if (typeof windowCenter === 'number' && typeof windowWidth === 'number') {
        center = windowCenter;
        width = windowWidth;
    }
    else if (Array.isArray(windowCenter) && Array.isArray(windowWidth)) {
        center = windowCenter[0];
        width = windowWidth[0];
    }
    if (center === undefined || width === undefined) {
        return;
    }
    return toLowHighRange(width, center, voiLUTFunction);
}
